var _mask, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 24,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 1.25H26.8711V22.935H3.75V1.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3088 3.125C10.94 3.125 7.89502 6.5475 7.89502 9.61875C7.89502 12.2175 7.17377 13.4187 6.53627 14.4788C6.02502 15.33 5.62127 16.0025 5.62127 17.4637C5.83002 19.8212 7.38627 21.06 15.3088 21.06C23.1875 21.06 24.7925 19.7663 25 17.3825C24.9963 16.0025 24.5925 15.33 24.0813 14.4788C23.4438 13.4187 22.7225 12.2175 22.7225 9.61875C22.7225 6.5475 19.6775 3.125 15.3088 3.125ZM15.3088 22.935C9.46377 22.935 4.18127 22.5225 3.75002 17.5438C3.74627 15.4837 4.37502 14.4362 4.93002 13.5138C5.49127 12.5787 6.02002 11.6975 6.02002 9.61875C6.02002 5.5775 9.75252 1.25 15.3088 1.25C20.865 1.25 24.5975 5.5775 24.5975 9.61875C24.5975 11.6975 25.1263 12.5787 25.6875 13.5138C26.2425 14.4362 26.8713 15.4837 26.8713 17.4637C26.435 22.5225 21.1538 22.935 15.3088 22.935Z",
    fill: "#000000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2478 28.125H15.2453C13.844 28.1238 12.5178 27.5063 11.5115 26.385C11.1653 26.0013 11.1965 25.4075 11.5815 25.0625C11.9665 24.715 12.559 24.7463 12.9053 25.1325C13.5528 25.8538 14.384 26.25 15.2465 26.25H15.2478C16.114 26.25 16.949 25.8538 17.5978 25.1313C17.9453 24.7475 18.5378 24.7163 18.9215 25.0625C19.3065 25.4088 19.3378 26.0025 18.9915 26.3863C17.9815 27.5075 16.6528 28.125 15.2478 28.125Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1f09669374c8529e8029fd6007e25bb6.svg";
export { ForwardRef as ReactComponent };